import { Link } from "react-router-dom";
import { footerLinks, partnerLinks } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg font-heading font-semibold">
                久
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                国产久久久
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300">
              国产久久久致力于整理与展示丰富的国产影视作品内容，涵盖电影、电视剧等多种题材，并结合影视资讯与专题报道，为您提供便捷、清晰的内容浏览体验。
            </p>
            <p className="mt-4 text-xs text-secondary-400 leading-relaxed">
              本站为内容展示与资讯平台，不提供播放、下载与支付服务，所有内容仅用于浏览与了解。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wide">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-secondary-300 hover:text-primary-300 transition-colors"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700/60 flex flex-col gap-6">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
            <span className="text-xs text-secondary-400 whitespace-nowrap">
              友情链接
            </span>
            {partnerLinks.map((name) => (
              <span
                key={name}
                className="text-xs text-secondary-300 whitespace-nowrap hover:text-primary-300 transition-colors cursor-pointer"
              >
                {name}
              </span>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">
              © {year} 国产久久久 · 国产影视资源与资讯平台
            </p>
            <p className="text-xs text-secondary-400">
              内容均为演示数据，版权归原权利人所有
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}